var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-switch',{staticClass:"ma-0 my-switch",attrs:{"readonly":_vm.isLoading,"hide-details":"","dense":"","loading":_vm.isLoading,"inset":""},on:{"change":_vm.onChange},model:{value:(_vm.formData.isAllowed),callback:function ($$v) {_vm.$set(_vm.formData, "isAllowed", $$v)},expression:"formData.isAllowed"}})
}
var staticRenderFns = []

export { render, staticRenderFns }